import logo from "@assets/images/sg-courts-logo-white.svg";
import cllogo from "@assets/images/cl-logo.png";

import preval from 'preval.macro'
function Footer() {

  return (
    <footer className="jds-footer">
	<div className="container">
		<div className="top-section sitemap">
			<h2 className="jds-footer-sitemap-header text-left mb-0"><img src={logo} alt=""/></h2>
		</div>
		<hr className="divider"/>
		<div className="bottom-section">
			<div className="row">
				<div className="col-lg-9 ">
					<div className="footer-links"> <a href="https://tech.gov.sg/report_vulnerability" target="_blank" rel="noreferrer">Report Vulnerability <i className="fal fa-external-link ml-1"></i></a> <a href="#">Privacy Statement</a> <a href="#">Terms of Use</a> <a href="https://www.reach.gov.sg/" target="_blank">Reach.gov.sg <i className="fal fa-external-link ml-1"></i></a> </div>
					<div className="powered-by mt-3">Powered by <img src={cllogo} alt=""/></div>
				</div>
				<div className="col-lg-3 mobile-mt-3 copyright text-right">
					<div>© {new Date().getFullYear()}  Government of Singapore</div>
					<div> Last updated: {preval`module.exports =new Date().toLocaleString().split(',')[0]`} v{process.env.REACT_APP_VERSION}</div>
				</div>
			</div>
		</div>
	</div>
</footer>
  );
}

export default Footer;
